export default {
    title: "Facturas",
    my_invoices: "Mis Facturas",
    filter_by_date: "Filtrar por fecha",
    status_label: "Estado",
    status_pending: "Pago Pendiente",
    status_overdue: "Atrasadas",
    status_paid: "Pagada",
    status_cancelled: "Cancelada",
    status_draft: "Borrador",
    status_overdue_label: "Atrasadas",
    issue_date: "Emisión",
    due_date: "Vencimiento",
    payment_date: "Fecha de pago",
    total_amount: "Monto Total",
    actions: "Acciones",
    export: "Exportar",
    add_charge: "Agregar Cargo",
    add_charge_subtitle: "Cree negociaciones adicionales en cuotas",
    generate_monthly: "Generar Facturas Mensuales",
    generate_monthly_title: "Generar facturas mensuales",
    generate_monthly_subtitle: "Revise lo que se eliminará y generará antes de confirmar.",
    generation_places: "Establecimientos",
    generation_to_generate: "A generar",
    generation_drafts_to_delete: "Borradores a eliminar",
    generation_blocked: "Mantenidas",
    generation_without_plan: "Sin plan",
    generation_selected: "{selected} de {total} seleccionadas",
    generation_select_all: "Seleccionar todas",
    generation_deselect_all: "Desmarcar todas",
    generation_main_target: "Matriz",
    generation_main_badge: "Matriz",
    generation_running: "Generando facturas mensuales...",
    generation_failed_places: "{count} establecimiento(s) no pudieron procesarse.",
    generation_without_plan_title: "Establecimientos activos sin plan",
    generation_without_plan_hint: "Estos establecimientos no tendrán facturas mensuales generadas hasta que se vincule un plan.",
    generation_no_changes: "No hay facturas mensuales para generar en los ciclos actuales de los planes.",
    generation_confirm: "Generar facturas",
    generation_preview_error: "No se pudo cargar la vista previa de generación de facturas mensuales.",
    generation_execute_error: "No se pudieron generar las facturas mensuales.",
    generation_success: "{generated} factura(s) generada(s) y {deleted} borrador(es) eliminado(s).",
    generation_partial_success: "{generated} factura(s) generada(s) y {deleted} borrador(es) eliminado(s), pero {failed} establecimiento(s) o {syncErrors} problema(s) de sincronización necesitan revisión.",
    establishment: "Establecimiento",
    branch: "Sucursal",
    paid_label: "Pagado:",
    pay_now: "Pagar ahora",
    pay: "Pagar",
    invoice: "Factura",
    delete_invoice: "Eliminar Factura",
    delete_confirmation: "¿Está seguro de que desea eliminar esta factura? Esta acción no se puede deshacer.",
    cancel: "Cancelar",
    yes_delete: "Sí, eliminar",
    attached_bank_slip: "Comprobante Adjunto",
    available_for_download: "Disponible para descargar",
    wait_a_moment: "Espere un momento",
    drag_pdf_here: "Arrastre su PDF aquí",
    or_click_to_select: "o haga clic en el botón de abajo para seleccionar",
    description: "Descripción",
    add_extra_cost: "Añadir costo extra",
    invoice_total: "Total de la Factura",
    total_paid: "Total Pagado",
    error_loading: "Error al cargar la factura",
    bank_slip_available: "Comprobante disponible",
    click_to_open_bank_slip: "Haga clic para abrir el comprobante bancario en una nueva pestaña.",
    add_charge_hint: "Valor cobrado en cada cuota. El total del contrato es este valor multiplicado por el número de cuotas.",
    not_informed: "No informado",
    view_details: "Ver Detalles",
    loading_details: "Cargando detalles de la factura...",
    load_error_not_found: "Factura no encontrada o acceso denegado.",
    load_error_general: "Ocurrió un error al cargar la factura. Intente nuevamente.",
    update_success: "¡Factura actualizada con éxito!",
    view_bank_slip: "Ver comprobante",
    bank_slip_unavailable_msg: "El comprobante aún no está disponible. Póngase en contacto con el soporte.",
    details_back: "Volver",
    delete_only_draft_error: "Solo se pueden eliminar facturas en borrador.",
    delete_success: "Factura eliminada con éxito.",
    delete_confirm_title: "Eliminar Factura",
    filter_status: "Estado",
    filter_establishment: "Establecimiento",
    n_invoices: "{count} facturas",
    cost_breakdown: "Desglose de Costos",
    comparing_with: "Comparando con:",
    remove_comparison: "Eliminar comparación",
    compare: "Comparar",
    no_other_monthly_invoices: "No hay otras facturas mensuales disponibles",
    loading_invoices: "Cargando facturas...",
    select_invoice: "Seleccionar factura...",
    quantity: "Cantidad",
    value: "Valor",
    total: "Total",
    no_detailed_costs_found: "No se encontraron costos detallados en esta factura.",
    no_invoices_found: "No se encontraron facturas",
    no_invoices_subtitle: "No hay facturas en el período seleccionado. Intenta cambiar el filtro de fechas.",
    subtotal: "Subtotal",
    interest_fines: "Multas y Intereses",
    discount_label: "Descuento",
    comparison_only_monthly_error: "La comparación solo es compatible con facturas mensuales.",
    item_base_plan: "Plan Base",
    item_contacts: "Contactos",
    item_extra_users: "Usuarios Extras",
    item_extra_branches: "Sucursales Extras",
    item_users: "Usuarios",
    item_branches: "Sucursales",
    active: "activos",
    included: "incluidos",
    extra: "extras",
    tooltip_active_users: "Usuarios activos",
    tooltip_included_users: "Usuarios incluidos en el plan",
    tooltip_extra_users: "Usuarios extras que serán cobrados en la factura",
    tooltip_active_branches: "Sucursales activas",
    tooltip_included_branches: "Sucursales incluidas en el plan",
    tooltip_extra_branches: "Sucursales extras que serán cobradas en la factura",
    item_integrations: "Disparadores",
    item_credits: "Créditos",
    item_extra_credits: "Créditos Extras",
    item_incentivized_sales_fee: "Tarifa por Ventas Incentivadas",
    item_retention_fee: "Tarifa por Retención",
    item_cost_adjustment: "Ajuste de Costo",
    item_extra_charge: "Cargo Extra",
    back_to_invoices: "Volver a Facturas",
    edit_invoice: "Editar Factura",
    save_changes: "Guardar Cambios",
    establishment_name: "Nombre del establecimiento",
    cnpj: "Identificación Fiscal",
    phone: "Teléfono",
    email: "Email",
    address: "Dirección",
    complement_short: "Compl.",
    neighborhood: "Barrio",
    city: "Ciudad",
    state_short: "Estado",
    zip_code_short: "CEP",
    invoice_title: "Título de la factura",
    period_label: "Periodo:",
    issue_date_label: "Fecha de Emisión:",
    due_date_label: "Vencimiento:",
    attach_bank_slip: "Adjuntar Comprobante",
    internal_notes: "Notas Internas",
    internal_notes_placeholder: "Añada notas internas sobre esta factura...",
    internal_notes_hint: "Estas notas son visibles solo para el equipo interno.",
    save_notes: "Guardar Notas",
    notes_saved_success: "¡Notas guardadas con éxito!",
    save_notes_error: "Error al guardar las notas internas.",
    slip_compensation_hint: "Los pagos vía comprobante pueden tardar hasta 3 días hábiles en compensarse.",
    change_status_to: "Cambiar estado a {label}",
    change_status_subtitle: "Está cambiando el estado de: {invLabel}. Confirme solo si este cambio es intencional.",
    change_status_confirm: "¿Está seguro de que desea cambiar el estado de esta factura a \"{label}\"? Esta acción puede afectar al cliente y a los registros financieros.",
    yes_change: "Sí, cambiar",
    wait_payment_title: "Esperar el pago de la factura",
    wait_payment_subtitle: "{invLabel} — el estado pasará a \"Esperando pago\".",
    check_bank_slip_hint: "Confirme que el comprobante sea correcto antes de cambiar el estado.",
    yes_change_status: "Sí, cambiar estado",
    will_be_cancelled_subtitle: "{invLabel} será marcada como cancelada.",
    cancel_invoice_hint: "Las facturas canceladas suelen salir del flujo de cobro activo. Confirme con finanzas antes de continuar.",
    yes_cancel_invoice: "Sí, cancelar factura",
    will_be_paid_subtitle: "{invLabel} será marcada como pagada.",
    mark_as_paid_hint: "Use esta opción solo cuando el pago haya sido efectivamente recibido y verificado.",
    yes_mark_as_paid: "Sí, marcar como pagado",
    attach_bank_slip_error: "Para poner en 'Esperando Pago', primero debe adjuntar el comprobante de la factura.",
    update_status_error: "Error al actualizar el estado.",
    update_status_connection_error: "Fallo de conexión al actualizar el estado.",
    update_error: "Error al guardar los cambios.",
    update_connection_error: "Fallo de conexión al guardar.",
    delete_error: "Error al eliminar la factura.",
    delete_connection_error: "Fallo de conexión al eliminar la factura.",
    confirm: "Confirmar",
    general: "General",
    remove: "Eliminar",
    loading: "Cargando...",
    // Bank Slip Management
    invoice_bank_slip: "Comprobante de la Factura",
    sending_document: "Enviando documento...",
    select_file: "Seleccionar Archivo",
    upload_bank_slip_hint: "Suba el comprobante en formato PDF (máximo 5MB).",
    view_pdf: "Ver PDF",
    view: "Ver",
    remove_file: "Eliminar archivo",
    remove_bank_slip_title: "Eliminar Comprobante",
    remove_bank_slip_confirm: "¿Está seguro de que desea eliminar el comprobante de esta factura?",
    yes_remove: "Sí, eliminar",
    only_pdf_error: "Solo se aceptan archivos PDF.",
    max_size_error: "El archivo debe tener como máximo 5MB.",
    upload_failure: "Error al subir el comprobante.",
    upload_connection_error: "Fallo de conexión al subir el comprobante.",
    remove_failure: "Error al eliminar el comprobante.",
    remove_connection_error: "Fallo de conexión al eliminar el comprobante.",
    // Add Charge Form
    select_establishment: "Seleccione un establecimiento",
    total_extra_value: "Valor de la cuota",
    installments: "Cuotas",
    first_due_date_label: "Primer vencimiento",
    select_date: "Seleccione una fecha",
    describe_negotiation: "Describa la negociación...",
    installments_preview: "Vista previa de las cuotas",
    installment: "Cuota",
    installments_sum: "Suma de las cuotas",
    creating_invoices: "Creando facturas...",
    create_n_invoices: "Crear {n} facturas",
    create_one_invoice: "Crear factura",
    charge_created_success: "¡{count} factura(s) creada(s) con éxito!",
    create_charge_error: "Error al crear el cobro.",
    connection_failure: "Fallo de conexión.",
    // Actions Menu
    cancel_invoice: "Cancelar Factura",
    delete_only_draft_hint: "Solo se pueden eliminar facturas en borrador",
    mark_as_paid: "Marcar como Pagado",
    no_changes_to_save: "No hay cambios para guardar.",
    generate_bank_slip: "Generar Boleto",
    bank_slip_generating: "Generando boleto...",
    bank_slip_generated_title: "Boleto generado con éxito",
    bank_slip_generated_hint: "El pago puede tardar hasta 3 días hábiles en confirmarse.",
    bank_slip_view_voucher: "Abrir página del boleto",
    bank_slip_copy_code: "Copiar código de pago",
    bank_slip_code_copied: "¡Código copiado!",
    bank_slip_expires_at: "Vence el",
    bank_slip_generation_error: "No fue posible generar el boleto. Intente nuevamente.",
    bank_slip_missing_tax_id: "CPF/CNPJ no informado en la factura. Actualice los datos de facturación antes de generar el boleto.",
    bank_slip_missing_cep: "CEP no informado en la factura. Actualice los datos de facturación antes de generar el boleto.",
    bank_slip_generation_success: "¡Boleto generado con sucesso!",
    bank_slip_generated_email_sent: "Boleto generado y correo enviado al contacto financiero.",
    send_invoice_email: "Enviar por correo",
    invoice_email_sent: "Correo de la factura enviado al contacto financiero.",
    invoice_email_failed: "No fue posible enviar el correo de la factura.",
    missing_tax_id_error: "El CPF o CNPJ del establecimiento no está informado. Complételo en el registro antes de generar el boleto.",
    missing_email_error: "El correo electrónico del establecimiento no está informado. Complételo en el registro antes de generar el boleto.",
    missing_cep_error: "El CEP del establecimiento no está informado. Complételo en el registro antes de generar el boleto.",
    minimum_amount_error: "El valor mínimo para generar el boleto es de R$ 5,00.",
    gateway_slip_cancel_warning_title: "Atención: Cancelación en el Gateway",
    gateway_slip_cancel_warning_body: "Este boleto se generó automáticamente. Al eliminarlo, se cancelará el cobro correspondiente en el gateway y el cliente ya no podrá pagarlo.",
    yes_cancel_and_remove: "Sí, cancelar y eliminar",
    export: "Exportar",
    export_success: "¡Facturas exportadas con éxito!",
    export_error: "Error al exportar facturas.",
    invoice_payment_link: "Enlace de Pago",
    payment_link_active_title: "Enlace de Pago Activo",
    payment_link_active_hint: "Los clientes pueden pagar con tarjeta de crédito o billeteras digitales a través de Stripe.",
    payment_link_hint: "Genera una página segura de Stripe Checkout para tarjetas de crédito nacionales e internacionales.",
    generate_payment_link: "Generar Enlace de Pago",
    payment_link_generating: "Generando enlace en Stripe...",
    payment_link_generation_success: "¡Enlace de pago generado con éxito!",
    payment_link_generation_error: "No fue posible generar el enlace de pago. Intente nuevamente.",
    payment_link_copy: "Copiar Enlace",
    payment_link_copied: "¡Enlace copiado!",
    payment_link_view: "Abrir Checkout",
    payment_link_remove: "Eliminar Enlace",
    payment_link_remove_confirm_title: "Eliminar Enlace de Pago",
    payment_link_remove_confirm_body: "¿Está seguro de que desea eliminar este enlace de pago? La sesión de Stripe caducará y no aceptará más pagos.",
    payment_link_remove_success: "Enlace de pago eliminado con éxito.",
    payment_link_remove_error: "Error al eliminar el enlace de pago.",
    payment_link_expires_at: "Vence el",
    choose_payment_method: "Elija cómo desea pagar",
    choose_payment_method_subtitle: "Seleccione una de las opciones de pago disponibles para esta factura:",
    pay_online_title: "Pagar en Línea (Tarjeta de Crédito)",
    pay_online_desc: "Pago instantáneo y seguro a través de Stripe con tarjeta o billeteras digitales.",
    pay_online_btn: "Pagar en Línea",
    pay_slip_title: "Boleto Bancario",
    pay_slip_desc: "Ver o imprimir el boleto para realizar el pago.",
    badge_credit_card: "Tarjeta de Crédito",
    badge_instant: "Instantáneo",
    badge_bank_slip: "Boleto",
    online_payment_available: "Pago en Línea Disponible",
    click_to_pay_online: "Haga clic para pagar con tarjeta de crédito o billeteras digitales a través de Stripe.",
    payment_unavailable_msg: "No hay ninguna opción de pago disponible para esta factura en este momento.",
    credits_whatsapp: "WhatsApp",
    credits_sms: "SMS",
    credits_rcs: "RCS",
    credits_email: "E-mail",
    credits_other: "Otros",
    compare_difference: "Diferencia",
    compare_unchanged: "Igual",
    compare_changed_hint: "Las filas destacadas cambiaron respecto a la factura comparada.",
    payment_correction_hint: "Corrija intereses, multa y el total pagado si el valor que entró en el banco es diferente."
};
